import { styled } from '@mui/material'
import React, { Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import AppLoader from 'components/ui-kit/AppLoader'
import { LOADER_TYPE } from 'utils/constants'
import CustomRoutes from './routes'
import AccessDenied from 'pages/AccessDenied/index'
import { ErrorBoundary } from 'react-error-boundary'
import ErrorHandler from 'components/layout/ErrorHandler/index'

const Routes = ({ pageLoader, ipAllowed, ipChecked }) => {
  return (
    <Router>
      <ErrorBoundary FallbackComponent={ErrorHandler}>
        <Suspense fallback={
          <StyledLoaderDiv>
            {!pageLoader && <AppLoader variant={LOADER_TYPE.SCALE} />}
          </StyledLoaderDiv>
        }
        >
          {!ipChecked
            ? <></>
            : ipAllowed
              ? <CustomRoutes />
              : <AccessDenied />}
        </Suspense>
      </ErrorBoundary>
    </Router>
  )
}

const StyledLoaderDiv = styled('div')({
  position: 'fixed',
  top: '50%',
  left: '50%',
  zIndex: 1
})

export default Routes
